import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingStatuses } from '@packages/shared/core/common/entities';
import { FlowName } from '@packages/shared/core/quiz/entities';
import { fetchRandomExpert, getRandomExpert, getRandomExpertReviews, getRandomExpertStatus } from '../store';

export function useGetRandomExpert(flowName: FlowName | 'seo') {
  const dispatch = useDispatch();

  const expert = useSelector(getRandomExpert);
  const reviews = useSelector(getRandomExpertReviews);
  const loadingStatus = useSelector(getRandomExpertStatus);

  useEffect(() => {
    if (loadingStatus !== LoadingStatuses.FULFILLED) {
      dispatch(fetchRandomExpert(flowName));
    }
  }, [dispatch, loadingStatus, flowName]);

  return {
    expert,
    reviews,
    loadingStatus,
  };
}
